import api from "../../services/api";
/**
 * @type {import("react-query").QueryFunction<{Nome: string, URL: string}[], ["Global", "Aplicativos"]>}
 */
export async function fetchAplicativos(agrupadorId = 1) {
    const { data } = await api.get(`/MobileService/api/Aplicativo/GET?agrupador=${agrupadorId}`);
    return data;
}

